var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99973 13.75C6.99966 13.8894 7.03844 14.026 7.1117 14.1446C7.18496 14.2631 7.28981 14.359 7.41448 14.4213L8.91448 15.1713C9.02885 15.2284 9.15594 15.2554 9.28366 15.2496C9.41139 15.2438 9.53551 15.2055 9.64425 15.1382C9.75299 15.0709 9.84273 14.977 9.90495 14.8653C9.96716 14.7536 9.99979 14.6279 9.99973 14.5V9.25C9.9999 8.87829 10.1381 8.51988 10.3875 8.24425L15.8047 2.2525C15.9018 2.14492 15.9657 2.01151 15.9886 1.86841C16.0114 1.72531 15.9924 1.57865 15.9337 1.44616C15.8749 1.31366 15.7791 1.20102 15.6577 1.12184C15.5364 1.04266 15.3946 1.00034 15.2497 1H1.74973C1.60468 1.00005 1.46277 1.04216 1.34117 1.12123C1.21957 1.20029 1.1235 1.31292 1.06461 1.44547C1.00571 1.57802 0.986519 1.72481 1.00935 1.86804C1.03218 2.01128 1.09605 2.14482 1.19323 2.2525L6.61198 8.24425C6.86138 8.51988 6.99956 8.87829 6.99973 9.25V13.75Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.cc176b31dce1c37a6dfd10be9eaf2ffa.svg";
export { ForwardRef as ReactComponent };